import { COVERAGE_INIT_LOADING, COVERAGE_INIT_SUCCESS, COVERAGE_INIT_FAIL, CLAUSELIST } from '@/store/types'
import Vue from 'vue'
export const coverage = {
  [COVERAGE_INIT_LOADING](state) {
    state.coverage.init = 0
    state.coverage.initErr = []
    state.coverage.menu = {}
  },
  [COVERAGE_INIT_SUCCESS](state, data) {
    state.coverage.init = 1
    state.coverage.initErr = []
    state.coverage.menu = data.menu
  },
  [COVERAGE_INIT_FAIL](state, error) {
    state.coverage.init = 2
    state.coverage.initErr = error
    state.coverage.menu = {}
  },
  [CLAUSELIST](state, clseList) {
    Vue.set(state, 'clseList', clseList)
  }
}
